module.exports = __webpack_public_path__ + "img/1.96cf05d8.png";